var SearchComponentJS = (function ($) {

    var searchFormSel = '#searchForm';
    var searchFieldSel = '.j-sf-input';
    var resultsMessageSel = '.j-results-message';
    var productTypeUrl = $('#j-productType').val() || "";
    var searchUrl = $('input[type=hidden]#facetsReloadUrl').val() || "/search/reload/facets";

    var priorityFacets = ['width', 'profile', 'constructionType', 'size'];

    var init = function () {
        if (window.localStorage.getItem('enablePreselectedCarAbTesting') && window.localStorage.getItem('tyreVehicleData')) {
            return;
        }
        $(SearchComponentJS.searchFieldSel).on('change', function () {
            var $this = $(this);
            clearNotAvailableParameters($this.closest(SearchComponentJS.searchFormSel));
            var searchForm = createJSONObject($this);
            retrieveAndSetupFacets(searchForm);
        });

        var select = $("input.j-sf-input, select:visible.j-sf-input");
        var minElement = select.first();
        select.each(function (index, val) {
            minElement = ($(val).data('index-no') < minElement.data('index-no') ? $(val) : minElement)
        });
        $(minElement).trigger('change');

    };

    var clearNotAvailableParameters = function ($form) {
        if (!$form.length) {
            return;
        }

        $form.find('select.not-available-parameter').removeClass('not-available-parameter');
        $form.find('option.not-available-parameter').remove();
    };

    var retrieveAndSetupFacets = function (searchForm) {
        searchForm["width"] = searchForm["width"] || '0';
        if (typeof landingPageFacetsExpirationSeconds === "undefined") {
            makeFacetsAjaxRequest(searchForm);
            return;
        }
        var data = getFacetsLocalStorage(searchForm);
        if (data) {
            handleSuccess(data, searchForm);
        } else {
            makeFacetsAjaxRequest(searchForm);
        }
    }

    var makeFacetsAjaxRequest = function (searchForm) {
        var extraParams = {};
        extraParams.contentType = "application/json; charset=utf-8";
        MainJS.untrackedAjaxCall(ACC.config.contextPath + productTypeUrl + searchUrl, "POST", JSON.stringify(searchForm), function (data) {
            handleSuccess(data, searchForm);
            if (typeof landingPageFacetsExpirationSeconds !== "undefined") {
                saveFacetsLocalStorage(data, searchForm);
            }
        }, function (xhr, status, error) {
            console.log("Ajax: Error" + error);
        }, extraParams);
    }

    var getFacetsLocalStorage = function (searchForm) {
        facets = getParsedFacets()
        if (!facets) {
            return
        }

        searchFormString = JSON.stringify(searchForm)
        storedFacetItem = facets[searchFormString]
        if (!storedFacetItem) {
            return
        }

        storedFacetItem = JSON.parse(storedFacetItem)
        if (new Date() < new Date(storedFacetItem.expirationDate)) {
            return storedFacetItem.data
        } else {
            delete facets[searchFormString]
            localStorage.setItem("landingPageFacets", JSON.stringify(facets));
        }
    }

    var saveFacetsLocalStorage = function (data, searchForm) {
        facets = getParsedFacets()
        if (!facets) {
            facets = {}
        }

        storedFacetItem = {}
        expirationDate = new Date();
        expirationDate.setSeconds(landingPageFacetsExpirationSeconds)
        storedFacetItem.expirationDate = expirationDate
        storedFacetItem.data = data

        facets[JSON.stringify(searchForm)] = JSON.stringify(storedFacetItem)
        localStorage.setItem("landingPageFacets", JSON.stringify(facets));
    }

    var getParsedFacets = function () {
        localStorageFacets = localStorage.getItem("landingPageFacets")
        if (!localStorageFacets) {
            return
        }

        return JSON.parse(localStorageFacets)
    }

    var createJSONObject = function (chObj) {
        var filterJSONObject = {};
        filterJSONObject.initiatorIndex = chObj.data('index-no');
        filterJSONObject.initiatorName = chObj.data('facet-name');
        filterJSONObject.initiatorValue = chObj.val();

        if (chObj.attr('type') === 'checkbox') {
            filterJSONObject.initiatorValue = chObj.is(":checked");
        } else {
            filterJSONObject.initiatorValue = chObj.val();
        }

        $('select' + SearchComponentJS.searchFieldSel + ' option:selected', $(SearchComponentJS.searchFormSel)).each(function () {
            handleBrandFilterJSONObject(filterJSONObject, this);
        });

        $('input[type=radio]' + SearchComponentJS.searchFieldSel + ':checked', $(SearchComponentJS.searchFormSel)).each(function () {
            var $this = $(this);
            var facetName = $this.data('facet-name');
            if ($this.val() !== '') {
                if (facetName === 'sowigan') {
                    if ($this.is(":checked")) {
                        filterJSONObject["season"] = $this.val();
                    }
                } else {
                    filterJSONObject[facetName] = $this.val();
                }
            }
        });

        $('input[type=checkbox]' + SearchComponentJS.searchFieldSel, $(SearchComponentJS.searchFormSel)).each(function () {
            var $this = $(this);
            var facetName = $this.data('facet-name');
            if (facetName === 'sowigan') {
                if ($this.is(":checked")) {
                    filterJSONObject["season"] = $this.val();
                }
            } else {
                filterJSONObject[facetName] = $this.is(":checked");
            }
        });

        $('input[type=text]' + SearchComponentJS.searchFieldSel, $(SearchComponentJS.searchFormSel)).each(function () {
            var $this = $(this);
            if ($this.val() !== '') {
                filterJSONObject[$this.data('facet-name')] = $this.val();
            }
        });

        $('input[type=hidden]' + SearchComponentJS.searchFieldSel, $(SearchComponentJS.searchFormSel)).each(function () {
            var $this = $(this);
            if ($this.val() !== '') {
                var thisName = $this.data('facet-name');
                if (thisName === 'vehicleTypes[0]' && $this.val() === 'MO') {
                    filterJSONObject['season'] = '';
                }

                if (thisName.indexOf('[') > -1) {
                    handleHiddenArray(filterJSONObject, $this);
                } else {
                    if (thisName === 'sowigan') {
                        filterJSONObject["season"] = true;
                        filterJSONObject["season"] = $this.val();
                    } else {
                        filterJSONObject[thisName] = true;
                        filterJSONObject[thisName] = $this.val();
                    }
                }
            }
        });

        if (typeof SearchComponentJS.additionalFiltering === "function") {
            SearchComponentJS.additionalFiltering(filterJSONObject);
        }

        return filterJSONObject;
    };

    var handleBrandFilterJSONObject = function (filterJSONObject, element) {
        var $this = $(element);
        if ($('input[name ="sizeTyresForMOEarlyBird"]').val() !== "noChanges") {
            var facetName = $this.parent().data('facet-name');
        }
        var value = $this.val();

        if (value !== '') {
            if (facetName === "brand") {
                value = [value];
            }
            if (facetName === "sowigan") {
                filterJSONObject["season"] = value;
                return;
            }
            if (filterJSONObject["season"] === "sogan" && facetName === "studded") {
                filterJSONObject[facetName] = "";
                return;
            }

            filterJSONObject[facetName] = value;
        }
    };

    var handleHiddenArray = function (filterJSONObject, elem) {
        var thisName = elem.data('facet-name');
        var thisNameStripped = thisName.substr(0, thisName.indexOf('['));

        if (filterJSONObject[thisNameStripped] === undefined) {
            filterJSONObject[thisNameStripped] = [elem.val()];
        } else {
            var prevValue = filterJSONObject[thisNameStripped];
            filterJSONObject[thisNameStripped][prevValue.length] = elem.val();
        }
    };

    var facetsContainFacetName = function (facets, facetCode) {
        var containsIndex = -1;
        $.each(facets, function (fi, facet) {
            if (facet.code === facetCode) {
                containsIndex = fi;
                return false; //exit $.each iteration
            }
        });

        return containsIndex;
    };

    var handleSuccess = function (data, requestObject) {
        // Update button state after facets are applied (not before),
        // otherwise the button can remain disabled even after user fixes the selection.
        if ("vehicleTypes[0]" !== requestObject.initiatorName) {
            $('[data-facet-name="' + requestObject.initiatorName + '"] option[fa=true]').remove();// remove previous added options that do not lead to results
        }
        var initiatorIndex = parseInt(requestObject.initiatorIndex) || -1;
        var initiatorValue = !('vehicleTypes' in requestObject) || typeof requestObject.vehicleTypes[0] === 'undefined' ? requestObject.initiatorValue : requestObject.vehicleTypes[0];
        $(SearchComponentJS.searchFormSel + ' ' + '[data-index-no]').filter(function () {
            return $(this).data("index-no") > initiatorIndex
        }).each(function () {
            var $formEl = $(this);
            var containsIndex = facetsContainFacetName(data.facets, $formEl.data('facet-name'));
            var facetName = $formEl.data('facet-name');

            if (facetName == 'width' || facetName == 'profile' || facetName == 'size') {
                var allText = ACC.optionAllSizes;
            } else {
                var allText = ACC.optionAll;
            }
            var all = $("option[value='']", $formEl) || "<option value=''>" + allText + "</option>";
            var allSelected = "<option value='' selected='selected'>" + allText + "</option>";

            if (containsIndex > -1) {
                var facet = data.facets[containsIndex];

                switch ($formEl.prop('tagName')) {
                    case "SELECT" : {

                        var $prevSelectedOption = $formEl.find('option:selected');
                        var selectedOptionVal = $prevSelectedOption.val();
                        var $prevSelectedOptionAdded = false;
                        var facetHadSelectedOption = facet.values.filter(function (fValue) {
                            return fValue.selected === true
                        }).length > 0;

                        if ($('input[name ="sizeTyresForMOEarlyBird"]').val() !== "noChanges") {
                            var isWidthFacet = $formEl.data('facet-name') === 'width';
                            var isProfileFacet = $formEl.data('facet-name') === 'profile';
                            var isSizeFacet = $formEl.data('facet-name') === 'size';
                        }
                        var isPriceCategoryFacet = $formEl.data('facet-name') === 'priceCategory';
                        var isStuddedFacet = $formEl.data('facet-name') === 'studded';
                        var isRunflatFacet = $formEl.data('facet-name') === 'runflat';

                        $('option', $formEl).remove();

                        var newSelectOptions = "";
                        $.each(facet.values, function (fvi, fValue) {
                            if ($formEl.hasClass('available') || $formEl.hasClass('unavailable')) {
                                newSelectOptions += "<option value='" + fValue.name + "' class='available'";
                            } else {
                                newSelectOptions += "<option value='" + fValue.name + "' ";
                            }
                            if (fValue.selected === true && facetHadSelectedOption === true) {
                                newSelectOptions += "selected='selected'";
                            }

                            if (selectedOptionVal === fValue.name && facetHadSelectedOption !== true) {
                                newSelectOptions += "selected='selected'";
                                $prevSelectedOptionAdded = true;
                            }

                            newSelectOptions += ">" + fValue.displayName + "</option>";
                        });

                        $formEl.append(newSelectOptions);

                        if ((isProfileFacet || isSizeFacet || isStuddedFacet || isRunflatFacet) && (!facetHadSelectedOption && !$prevSelectedOptionAdded)) {
                            $formEl.prepend(allSelected);
                            facetHadSelectedOption = true;
                        } else if (!$prevSelectedOptionAdded && !facetHadSelectedOption) {
                            if ($prevSelectedOption.val() !== '') {
                                $prevSelectedOption.attr('fa', true);
                                $prevSelectedOption.addClass("not-available-parameter");
                            }
                            $formEl.prepend($prevSelectedOption.prop('selected', true));
                        }

                        var allExists = $("option[value='']", $formEl).length > 0;
                        if (!isWidthFacet && !isPriceCategoryFacet && !allExists) {
                            $formEl.prepend(all);
                        }

                        var $selected = $formEl.find("option:selected");
                        if ($selected.length > 0 && ($selected.attr("fa") || $selected.hasClass("not-available-parameter"))) {
                            $selected.addClass("not-available-parameter");
                            $formEl.addClass("not-available-parameter");
                        } else {
                            $formEl.removeClass("not-available-parameter");
                        }

                        break;
                    }
                    case "INPUT" : {
                        break;
                    }
                }
            } else {
                var facetName = $formEl.data('facet-name');
                if (facetName === priorityFacets[0] || facetName === priorityFacets[1] || facetName === priorityFacets[2] || facetName === priorityFacets[3]) {
                    $('option', $formEl).remove();
                    $formEl.append(all);
                } else {
                    var $prevSelected = $('option:selected', $formEl);
                    $('option', $formEl).remove();
                    $formEl.append($prevSelected);
                }
            }
        });
        facetUpdatedNotify(data, requestObject);

        if (window.localStorage.getItem('enablePreselectedCarAbTesting')
            && window.localStorage.getItem('tyreVehicleData')
            && initiatorValue === "PKW") {
            clearHighlightedTyreParam();
            updateDimensionsFromPreselectedCarEbon();
        }

        handleResultsAttributes(data.pagination.totalNumberOfResults, data.lastFacet);
    };

    var clearHighlightedTyreParam = function () {
        var button = getVehicleTypeFromSearchForm();
        button.closest("form").find("select.searchFormField").each(function () {
            if ($(this).hasClass("not-available-parameter") && $(this).find("option.not-available-parameter").length === 0) {
                $(this).removeClass("not-available-parameter");
            }
        });
    };

    var updateDimensionsFromPreselectedCarEbon = function () {

        var vehicleTypesForDisplayingPreselectedCar = ["OFF", "ALL_TERRAIN_OFF", "MUD_TERRAIN_OFF", "HIGHWAY_TERRAIN_OFF", "PKW",
            "LLKW", "VINTAGE_PKW", "VINTAGE_LLKW", "RACE_PKW", "SL", "FB"];

        var vehicleType = $(".search-filter-tab-1 #searchForm input[name=vehicleTypes]");

        if (vehicleType.length === 0) {
            return;
        }

        var homeSearchButton = $("#searchForm .search-filter-footer__result-button.btn-wrapper");
        homeSearchButton.attr("disabled", false);

        if (vehicleTypesForDisplayingPreselectedCar.indexOf(vehicleType.val()) === -1) {
            return;
        }

        var vehicleData = JSON.parse(window.localStorage.getItem('tyreVehicleData'));
        if (!vehicleData.width && !vehicleData.tyreProfile && !vehicleData.size) {
            return;
        }
        $("#search-filter-width").val(vehicleData.width);
        $("#search-filter-profile").val(vehicleData.tyreProfile);
        $("#search-filter-size").val(vehicleData.size);

        if ($("#search-filter-width").val() === null) {
            showNotAvailableParameter($("#search-filter-width"), vehicleData.width);
        }

        if ($("#search-filter-profile").val() === null) {
            showNotAvailableParameter($("#search-filter-profile"), vehicleData.tyreProfile);
        }

        if ($("#search-filter-size").val() === null) {
            showNotAvailableParameter($("#search-filter-size"), vehicleData.size);
        }

        ifNotSelectedAllDimensions(homeSearchButton);
    };

    function showNotAvailableParameter($searchFormParam, $preselectedCarParam) {
        $searchFormParam.append($("<option>", {
            value: $preselectedCarParam,
            text: $preselectedCarParam,
            selected: "selected",
            class: "not-available-parameter"
        })).addClass("not-available-parameter");
    }

    function ifNotSelectedAllDimensions($submitFormButton) {

        if ($submitFormButton.closest("form").find(".not-available-parameter").length > 0) {
            $submitFormButton.attr("disabled", true);
        }
    }

    var getVehicleTypeFromSearchForm = function () {

        //ebon home page search
        var vehicleTypeEbon = $(".search-filter-tab-1 #searchForm input[name=vehicleTypes]");

        var vehicleType = "";
        if ($("#submit_button #search").length || $("#s_q #search").length || $("#suchen4").length || $("#valid.btn").length) {
            var submitFormButton;
            if ($("#submit_button #search").length) {
                submitFormButton = $("#submit_button #search");
            } else {
                if ($("#s_q #search").length) {
                    submitFormButton = $("#s_q #search");
                } else {
                    if ($("#suchen4").length) {
                        submitFormButton = $("#suchen4");
                    } else {
                        submitFormButton = $("#valid.btn");
                    }
                }
            }
            if (submitFormButton) {
                vehicleType = submitFormButton.closest("form").find("input[name='vehicleTypes']");
            }
        }
        return vehicleType ? vehicleType : vehicleTypeEbon;
    };

    var handleResultsAttributes = function (resultsNumber, lastFacet) {
        var $form = $(SearchComponentJS.searchFormSel);
        var hasNotAvailableParams = $form.find(".not-available-parameter").length > 0;
        $(resultsMessageSel).html(ACC.searchResultsNumberProvide + ' ' + resultsNumber + ' ' + ACC.searchResultsNumberResults)
            .removeClass("no-search-results-message");
        if (resultsNumber === 0 || hasNotAvailableParams) {
            $form.find('input[type=submit]').prop('disabled', true);
            suggestFacetChange(lastFacet);
        } else {
            $form.find('input[type=submit]').prop('disabled', false);
        }
    };

    var suggestFacetChange = function (lastFacet) {
        if (lastFacet) {
            var message = ACC.getParametrizedString(getSuggestionText(resultsMessageSel), lastFacet, "<a class='j-search-by-car'>", "</a>");
            $(resultsMessageSel).html(message).addClass("no-search-results-message");

            $(".j-search-by-car").on("click", function () {
                $('ul.nav a[href="#pane2"]').tab('show');
            });
        }
    };

    var getSuggestionText = function (resultsMessageSel) {
        if ($(resultsMessageSel).data("by-car-available") == 'true') {
            return ACC.searchResultsNumberNoResults + ACC.suggestSearchByCar;
        } else {
            return ACC.searchResultsNumberNoResults;
        }
    };

    var facetUpdatedNotify = function (data, requestObject) {
        $(window).trigger("search:facetsUpdated", [data, requestObject]);
    };

    var setupQuickOrderAction = function (btnSel) {
        $(btnSel).on('click', function () {
            var $this = $(this);
            var callData = {};
            callData.productCode = $this.attr('attr-productCode');
            callData.productFmtPrice = $this.attr('attr-productFmtPrice');
            callData.inStock = $this.attr('attr-inStock');
            callData.productShortDescription = $this.attr('attr-productShortDescription');
            MainJS.ajaxCall($this.attr("attr-href"), "GET", callData, function (data) {
                var $data = $(data);
                $.fancybox({
                    width: 500,
                    height: 'auto',
                    fitToView: true,
                    autoSize: false,
                    content: $data,
                    helpers: {
                        overlay: {
                            locked: false
                        }
                    }
                });
            }, null, {});
        });
    };

    return {
        createJSONObject: createJSONObject,
        searchFieldSel: searchFieldSel,
        searchFormSel: searchFormSel,
        handleSuccess: handleSuccess,
        init: init,
        setupQuickOrderAction: setupQuickOrderAction
    };

})(jQuery);

$(document).ready(function () {
    SearchComponentJS.init();
    SearchComponentJS.setupQuickOrderAction(".j-quickOrderBtn");
});
